function toPlainObject(e){return copyObject(e,keysIn(e))}var copyObject=require("./_copyObject"),keysIn=require("./keysIn");module.exports=toPlainObject;